import { omit, get } from 'lodash';
export const getValidationRowState = (state, id) => state.validation[id] || {};
export const getValidationsForAddPayee = (state) => state.validation.addPayee || {};
export const getValidationsIFTPaymentDetails = (state) => get(state, 'validation.iftPaymentDetails', {});

export const getValidationsForAddInternationalPayee = (state, isEditPayee) => {
	if (isEditPayee) {
		return state.validation.editInternationalPayee;
	}
	return state.validation.addInternationalPayee || {};
};

const getInvalidItems = (block) => Object.keys(block).filter((itemKey) => !block[itemKey].isValid);

export const formValid = (state) => {
	const { validation } = state;
	const keys = Object.keys(omit(validation, 'paymentType'));
	const inValidItems = keys.filter((key) => getInvalidItems(validation[key]).length);
	return inValidItems.length === 0;
};

export const isSpecificFormValid = ({ validation }, id) => {
	if (validation[id]) {
		return getInvalidItems(validation[id]).length === 0;
	}
	return false;
};

export const isSpecificFormKeyValid = (state, id, key) => get(state, ['validation', id, key, 'isValid'], false);

export const isIFTPaymentDetailsFormValid = (state) => isSpecificFormValid(state, 'iftPaymentDetails');

export const isFormValidForRatesApiCall = (state) => {
	/** @note `reason` and `validation` will be `undefined` if there are no `iftPaymentDetails` in `state.validation So adding a default to get fn call` */
	const { reason, ...iftPaymentDetailsItems } = get(state, ['validation', 'iftPaymentDetails'], {});
	return getInvalidItems(iftPaymentDetailsItems).length === 0;
};
